let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("XmYfq")).then(() => parcelRequire('it8QE'));